import * as v from "valibot";

const schema = v.object({ tagIds: v.array(v.string()) });

export type Schema = v.InferOutput<typeof schema>;

export { schema };
